import Button from "lib/components/atomic/Button";
import Image from "next/image";
import Link from "next/link";
import SEO from "lib/components/SEO";

function Custom404() {
  return (
    <div className="container mx-auto flex flex-col sm:flex-row justify-center items-center w-screen min-h-screen py-8 sm:py-15">
      {/* This component doubles as Next's real not-found page (which
          already returns a true HTTP 404) AND as an inline fallback other
          pages render client-side for an invalid/missing id -- that second
          case still returns HTTP 200, so without this noindex tag Google
          happily indexes junk like /exam/undefined or /classrooms/[slug]
          as thin duplicate content. Found via Search Console: those exact
          URLs were showing up with real impressions. */}
      <SEO noindex title="Page Not Found | Clamphook Academy" />
      {/*description */}
      <div className=" w-2/5">
        <div className="font-bold mb-10 text-4xl">
          Something <br /> Missing
        </div>
        <div className="mb-15">
          May your next exam be as awesome as
          <br />
          you are. Also the page you&apos;re looking for
          <br /> doesn&apos;t exist.
        </div>

        <Link href="/">
          {/* @next-codemod-error This Link previously used the now removed `legacyBehavior` prop, and has a child that might not be an anchor. The codemod bailed out of lifting the child props to the Link. Check that the child component does not render an anchor, and potentially move the props manually to Link. */}
          <Button className="bg-primary-600 font-bold px-7 py-4 text-lg rounded-[8px] text-white">
            Go back to homepage
          </Button>
        </Link>
      </div>
      <div>
        <Image
          src="/svg/error404.svg"
          width={625}
          height={410}
          alt="landing blobby"
        />
      </div>
    </div>
  );
}

export default Custom404;
